import { Component, OnDestroy, OnInit, ViewContainerRef, ComponentRef, ComponentFactoryResolver, Injector } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Subscription } from "rxjs";
import { URLS } from "src/app/_config/api.config";
import { ApiService } from '../../_services/api-data.service';
import { ModalController, AlertController } from '@ionic/angular';
import { CommonService } from '../../_services/common.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../_services/toast.service';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { ModalService } from '../../_services/modal.service';
import { ProductPreviewDetailComponent } from '../product-preview-detail/product-preview-detail.component';
import { ProductPreviewComponent } from '../product-preview/product-preview.component';
import { Router } from '@angular/router';
import { ImageGalleryModalComponent } from './image-gallery-modal.component';
// import { AddEditProductComponent } from "../add-edit-product/add-edit-product.component";

@Component({
    selector: "app-bulk-upload-modal",
    templateUrl: "./bulk-upload-modal.component.html",
    styleUrls: ["./bulk-upload-modal.component.scss"]
})
export class BulkUploadModalComponent implements OnInit, OnDestroy {
    // categoryList is now fetched from API, but kept for backward compatibility
    categoryList: any[] = [];

    selectedSubClass: any = [];
    showSubClassError = false;
    tempBtnLoading: boolean = false;
    fileList1: any[] = [];
    public files: NgxFileDropEntry[] = []; // For ngx-file-drop
    selectedFile: any; // Store the actual File object
    selectedSubClassID: any;
    modelLoader: boolean = false;
    currentStep: number = 0;
    uploadResponseData: any = null;
    uploadCompleted: boolean = false;
    successfulProducts: any[] = []; // Keep for backward compatibility, but use previewResponse data on step 1
    isUploading: boolean = false;
    progress: number = 0; // For file upload progress
    
    // Get products from preview response for step 1
    getPreviewProducts(): any[] {
        if (this.previewResponseData && this.previewResponseData.data && this.previewResponseData.data.products && Array.isArray(this.previewResponseData.data.products)) {
            return this.previewResponseData.data.products;
        }
        return [];
    }

    // Get product key (product_code or product_id) for use as identifier
    getProductKey(product: any): string {
        return product.product_code || `product_${product.product_id}`;
    }
    bulkAddResponseData: any = null;
    previewResponseData: any = null;
    jobId: string | number | null = null; // Store job_id from import API response
    errorFileUrl: string | null = null; // Store file_url from import API response (invalid error file)
    
    // Document upload tracking
    productDocuments: any = {};
    productDocumentFileLists: any = {};
    documentUploading: any = {}; // Track uploading state for each document field
    masterDocumentList: any[] = []; // Master document list from API
    documentTypes: any[] = []; // Will be populated from master API and preview response

    // Image upload tracking
    productImageModes: any = {}; // 'common' or 'unique'
    productWebImages: any = {}; // Web images for each product
    productMobileImages: any = {}; // Mobile images for each product
    productVariationWebImages: any = {}; // Web images for variations
    productVariationMobileImages: any = {}; // Mobile images for variations
    productImageFileLists: any = {}; // File lists for nz-upload
    imageUploading: any = {}; // Track uploading state for images (productCode -> {web: boolean, mobile: boolean})
    productWebZipFiles: any = {}; // Store temporary web ZIP files before upload (productCode -> file)
    productMobileZipFiles: any = {}; // Store temporary mobile ZIP files before upload (productCode -> file)
    variationWebZipFiles: any = {}; // Store temporary web ZIP files for variations (productCode -> {variationKey -> file})
    variationMobileZipFiles: any = {}; // Store temporary mobile ZIP files for variations (productCode -> {variationKey -> file})
    
    // Carousel indices for image navigation
    webImageCarouselIndices: any = {}; // productCode -> index
    mobileImageCarouselIndices: any = {}; // productCode -> index
    variationWebImageCarouselIndices: any = {}; // productCode -> variationKey -> index
    variationMobileImageCarouselIndices: any = {}; // productCode -> variationKey -> index

    // UI state tracking (not caching - these track current session state)
    documentStatusCache: any = {};
    expandedProductRows: any = {};
    expandedImageProductRows: any = {};
    expandedPreviewProductRows: any = {}; // Track expanded state for preview step
    subclassOnly: any[] = [];
    subclassList: any[] = []; // For ng-select dropdown

    private subscription: Subscription = new Subscription();

    notFoundText: string;

    constructor(
        public notification: NzNotificationService,
        public dataService: ApiService,
        private modal: NzModalService,
        private sanitizer: DomSanitizer,
        private viewContainerRef: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector,
        private modalCtrl: ModalController,
        private alertController: AlertController,
        public commonService: CommonService,
        private config: NgSelectConfig,
        private translate: TranslateService,
        private toastService: ToastService,
        private http: HttpClient,
        private modalService: ModalService,
        private router: Router
    ) {
        this.notFoundText = this.translate.instant('noItemFound');
        this.config.notFoundText = this.notFoundText;
    }

    ngOnInit(): void {
        // Call API to get subclasses (same as mass-upload component)
        this.getSubclasses();
    }

    // Removed ngAfterViewInit and ngOnChanges - no longer needed with Ionic ModalController

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    processCategoryList(): void {
        this.subclassOnly = [];
        if (this.categoryList && this.categoryList.length > 0) {
            this.categoryList.forEach(element => {
                element.key = element.type === 'group' ? 'group' + element.id + element.level : 
                    element.type === 'Categories' ? 'category' + element.id + element.level : 
                    element.type === 'Classes' ? 'class' + element.id + element.level : 
                    element.type === 'Sub Classes' ? 'subClass' + element.id + element.level : element.id;
                this.treeLoop(element);
            });
        }
    }

    // Fetch master document list from API - THIS SHOWS ALL DOCUMENTS
    fetchMasterDocumentList(): void {
        this.subscription.add(
            this.dataService.get(URLS.activeDocumentList, {}).subscribe(
                (data) => {
                    if (data && data['code'] == 200 && data['data']) {
                        this.masterDocumentList = data['data'];
                        // Map documents - THIS WILL SHOW ALL DOCUMENTS FROM MASTER API
                        // Users can upload ANY document, even if not in preview response
                        this.mapDocumentsWithPreview();
                    } else {
                        this.notification.error('Error', data['message'] || 'Failed to load document types');
                    }
                },
                (error) => {
                    this.notification.error('Error', error.error?.message || 'Failed to load document types');
                }
            )
        );
    }

    // Fetch master document list and then call preview API (for step 1)
    // This is called every time user enters step 1 (via next or previous)
    fetchMasterDocumentListAndPreview(): void {
        
        // Clear previous data to ensure fresh fetch
        this.masterDocumentList = [];
        this.documentTypes = [];
        this.previewResponseData = null;
        
        // First, fetch master document list
        this.subscription.add(
            this.dataService.get(URLS.activeDocumentList, {}).subscribe(
                (data) => {
                    if (data && data['data']) {
                        this.masterDocumentList = data['data'];
                        
                        // After master document list is loaded, call preview API
                        this.callBulkProductPreview();
                    } else {
                        this.modelLoader = false;
                        this.notification.error('Error', data['message'] || 'Failed to load document types');
                    }
                },
                (error) => {
                    this.modelLoader = false;
                    this.notification.error('Error', error.error?.message || 'Failed to load document types');
                }
            )
        );
    }

    // Map master document list - shows ALL documents from master API
    // Don't set documents as required based on preview response
    mapDocumentsWithPreview(): void {
        if (!this.masterDocumentList || this.masterDocumentList.length === 0) {
            console.warn('Master document list is empty, cannot map documents');
            this.documentTypes = [];
            return;
        }

        // Transform master document list to match current structure
        // Show ALL documents from master API - don't set required based on preview
        this.documentTypes = this.masterDocumentList.map((doc: any) => {
            return {
                key: doc.document_type_id.toString(), // Use document_type_id as key
                document_type_id: doc.document_type_id,
                label: doc.document_type_en,
                label_ar: doc.document_type_ar,
                required: false, // Don't set as required based on preview
                max_documents_to_upload: doc.max_documents_to_upload || 1
            };
        });


        // Re-initialize product documents if successful products are already loaded
        if (this.successfulProducts && this.successfulProducts.length > 0) {
            this.initializeProductDocuments();
        }
    }

    treeLoop(data: any): void {
        if (data.children && data.children.length) {
            data.children.forEach((ele1: any) => {
                ele1.key = ele1.type === 'group' ? 'group' + ele1.id + ele1.level : 
                    ele1.type === 'Categories' ? 'category' + ele1.id + ele1.level : 
                    ele1.type === 'Classes' ? 'class' + ele1.id + ele1.level : 
                    ele1.type === 'Sub Classes' ? 'subClass' + ele1.id + ele1.level : ele1.id;
                if (ele1.type === 'Sub Classes') {
                    this.subclassOnly.push(ele1);
                }
                if (ele1.children && ele1.children.length) {
                    this.treeLoop(ele1);
                }
            });
        }
    }

    nodeClicked(event: any, node: any): void {
        if (node.origin.type != 'Sub Classes') {
            event.preventDefault();
            event.stopPropagation();
        }
        if (node._children.length != 0 || node.origin.type != 'Sub Classes') {
            node.isSelectable = false;
        }
    }

    onSubClassChange(value: any): void {
        this.selectedSubClass = value;
        if (value) {
            // Handle ng-select format (subclass123) or nz-tree-select format
            const subclassId = typeof value === 'string' ? value.replace(/subclass/g, '') : value;
            let obj = this.subclassOnly.find(el => el.id == subclassId || el.key == value || ('subclass' + el.id) == value);
            if (obj) {
                this.selectedSubClassID = obj.id;
            } else if (typeof subclassId === 'string' && !isNaN(Number(subclassId))) {
                this.selectedSubClassID = Number(subclassId);
            }
        }
        setTimeout(() => {
            this.checkAndAutoUpload();
        }, 100);
    }

    subclassChanged(event: any): void {
        // Handler for ng-select change event
        this.onSubClassChange(event);
    }

    // Get subclasses from API (same as mass-upload component)
    getSubclasses(): void {
        const params = {
            page: 0,
            limit: 0,
            status: true,
            dropdown: true,
        };
        this.subscription.add(
            this.dataService.get(URLS.consolidatedGroup, params).subscribe(
                (data) => {
                    if (data['code'] == 200) {
                        if (data['data'] && data['data'].length) {
                            let list = data['data'][0]['list'];
                            this.subclassList = [];
                            this.subClassModelStructure(list);
                            // Also process for nz-tree-select compatibility (if still needed)
                            this.categoryList = list;
                            this.processCategoryList();
                        }
                    } else {
                        if (data['code'] != 204) {
                            this.toastService.displayToast(data['message'], null, 'danger');
                        }
                    }
                },
                (error) => {
                    this.toastService.displayToast(error['message'], null, 'danger');
                }
            )
        );
    }

    // Process subclass structure (same as mass-upload component)
    subClassModelStructure(list: any[]): void {
        list.forEach((group: any) => {
            let groupObj: any = {
                name: this.commonService.domDirectionLTR ? group.title : group.title_ar,
                type: group.type,
                level: group.level,
                id: group.id,
                children: group.children,
            };
            if (group.children && group.children.length) {
                groupObj['children'] = group.children;
                let groupChildren: any[] = [];
                group.children.forEach((category: any) => {
                    let categoryObj: any = {};
                    categoryObj['name'] = this.commonService.domDirectionLTR ? category.title : category.title_ar;
                    categoryObj['type'] = category.type;
                    categoryObj['level'] = category.level;
                    categoryObj['id'] = category.id;
                    categoryObj['children'] = category.children;
                    let categoryChildren: any[] = [];
                    if (category.children && category.children.length) {
                        category.children.forEach((classes: any) => {
                            let classObj: any = {};
                            classObj['name'] = this.commonService.domDirectionLTR ? classes.title : classes.title_ar;
                            classObj['type'] = classes.type;
                            classObj['level'] = classes.level;
                            classObj['id'] = classes.id;
                            let subclasses: any[] = [];
                            if (classes.children && classes.children.length) {
                                classes.children.forEach((subclass: any) => {
                                    let subclassObj: any = {};
                                    subclassObj['name'] = this.commonService.domDirectionLTR ? subclass.title : subclass.title_ar;
                                    subclassObj['type'] = subclass.type;
                                    subclassObj['level'] = subclass.level;
                                    subclassObj['id'] = 'subclass' + subclass.id;
                                    subclasses.push(subclassObj);
                                });
                            }
                            classObj['children'] = subclasses && subclasses.length ? subclasses : [];
                            if (classObj['children'] && classObj['children'].length) {
                                categoryChildren.push(classObj);
                            }
                        });
                    }
                    categoryObj['children'] = categoryChildren && categoryChildren.length ? categoryChildren : [];
                    if (categoryObj['children'] && categoryObj['children'].length) {
                        groupChildren.push(categoryObj);
                    }
                });
                groupObj['children'] = groupChildren && groupChildren.length ? groupChildren : [];
            }
            if (groupObj['children'] && groupObj['children'].length) {
                this.subclassList.push(groupObj);
            }
        });
    }

    isStep1Valid(): boolean {
        const hasSubClass = this.selectedSubClass && 
            (Array.isArray(this.selectedSubClass) ? this.selectedSubClass.length > 0 : true);
        const hasFile = (this.selectedFile || (this.fileList1 && this.fileList1.length > 0));
        return hasSubClass && hasFile;
    }

    canProceedToNextStep(): boolean {
        if (!this.uploadCompleted || !this.uploadResponseData) {
            return false;
        }

        if (this.uploadResponseData.data && this.uploadResponseData.data.summary) {
            const summary = this.uploadResponseData.data.summary;
            let successfulVariations = 0;

            if (summary.successful_variations !== undefined && summary.successful_variations !== null) {
                successfulVariations = summary.successful_variations;
            } else if (summary.total_variations !== undefined && summary.failed_variations !== undefined) {
                successfulVariations = (summary.total_variations || 0) - (summary.failed_variations || 0);
            }

            return successfulVariations > 0;
        }
        
        return false;
    }

    extractSuccessfulVariations(): any[] {
        const successfulVariations: any[] = [];
        
        if (this.uploadResponseData && this.uploadResponseData.data && this.uploadResponseData.data.successfulProducts) {
            const successfulProducts = this.uploadResponseData.data.successfulProducts;
            
            successfulProducts.forEach((product: any) => {
                if (product.variations && Array.isArray(product.variations)) {
                    product.variations.forEach((variation: any) => {
                        if (variation.status === 'success') {
                            successfulVariations.push(variation);
                        }
                    });
                }
            });
        }
        
        return successfulVariations;
    }

    callBulkProductAdd(): void {
        const successfulVariations = this.extractSuccessfulVariations();
        
        if (successfulVariations.length === 0) {
            this.notification.error('Error', 'No successful variations found');
            return;
        }

        const payload: any = {
            sub_class_id: this.selectedSubClassID,
        };
        
        // Add job_id if available
        if (this.jobId) {
            payload.job_id = this.jobId;
        }


        this.tempBtnLoading = true;
        this.subscription.add(
            this.dataService.post(URLS.bulkProductAdd, payload).subscribe(
                (data) => {
                    if (data && data['code'] == 200) {
                        this.bulkAddResponseData = data;
                        this.callBulkProductPreview()
                        this.tempBtnLoading = false;
                        // Preview API will be called when entering step 1 (in fetchMasterDocumentListAndPreview)
                    } else {
                        this.tempBtnLoading = false;
                        this.notification.error('Error', data['message'] || 'Failed to add bulk products');
                    }
                },
                (error) => {
                    this.tempBtnLoading = false;
                    console.error('Bulk add error:', error);
                    this.notification.error('Error', error.error?.message || 'Failed to add bulk products');
                }
            )
        );
    }

    // Call preview API - always fetches fresh data (no caching)
    callBulkProductPreview(isFinalCall: boolean = false): void {
        // Set loader to show loading state
        this.modelLoader = true;
        // Clear previous preview data to ensure fresh fetch (no caching)
        this.previewResponseData = null;
        // const productIds = this.bulkAddResponseData.data.results.map((result: any) => result.main_product_id);

        const payload: any = {};
        
        // Add job_id if available
        if (this.jobId) {
            payload.job_id = this.jobId;
        } else {
            this.notification.error('Error', 'Bulk add response data not available');
            this.modelLoader = false;
            return;
        }
        
        // Add is_final_call when moving from preview step (step 3) to complete step (step 4)
        if (isFinalCall) {
            payload.is_final_call = true;
        }


        this.tempBtnLoading = true;
        this.subscription.add(
            this.dataService.post(URLS.bulkProductPreview, payload).subscribe(
                (data) => {
                    if (data && data['code'] == 200) {
                        this.previewResponseData = data;
                        this.tempBtnLoading = false;
                        
                        
                        // Map documents with preview response after preview is loaded
                        if (this.masterDocumentList && this.masterDocumentList.length > 0) {
                            this.mapDocumentsWithPreview();
                        }
                        
                        // Prefill documents/images based on current step - always refresh data (no caching)
                        if (this.currentStep === 1) {
                            // Step 1: Initialize documents from preview response
                            this.initializeProductDocuments();
                            this.modelLoader = false; // Hide loader after documents are initialized
                        } else if (this.currentStep >= 2) {
                            // Step 2 or later: Initialize images from preview response
                            // This ensures images are refreshed every time preview API is called (e.g., after ZIP upload)
                            this.initializeProductImages();
                            this.modelLoader = false;
                        } else {
                            this.modelLoader = false;
                        }
                        
                    } else {
                        this.tempBtnLoading = false;
                        this.modelLoader = false;
                        this.notification.error('Error', data['message'] || 'Failed to load product preview');
                    }
                },
                (error) => {
                    this.tempBtnLoading = false;
                    this.modelLoader = false;
                    console.error('Preview error:', error);
                    this.notification.error('Error', error.error?.message || 'Failed to load product preview');
                }
            )
        );
    }

    nextStep(): void {
        if (this.currentStep === 0 && this.canProceedToNextStep()) {
            this.callBulkProductAdd();
            
            this.currentStep = 1;
            if (this.uploadResponseData && this.uploadResponseData.data && this.uploadResponseData.data.successfulProducts) {
                this.successfulProducts = this.uploadResponseData.data.successfulProducts;
                // When entering step 1, fetch master document list first, then call preview API
                this.modelLoader = true;
                this.fetchMasterDocumentListAndPreview();
            }
        } else if (this.currentStep === 1) {
            // No validation required - documents are optional
            // When moving to step 2, call preview API to get latest data
            this.currentStep = 2;
            this.modelLoader = true;
            this.callBulkProductPreview();
        } else if (this.currentStep === 2) {
            // Images are optional - can proceed without validation
            // When moving to step 3 (preview), call preview API to get latest data
            this.currentStep = 3;
            this.modelLoader = true;
            this.callBulkProductPreview();
        } else if (this.currentStep === 3) {
            // When moving from step 3 (preview) to step 4 (complete), call preview API with is_final_call
            this.currentStep = 4;
            this.modelLoader = true;
            this.callBulkProductPreview(true); // Pass true to indicate final call
        } else if (this.currentStep > 2 && this.currentStep < 4) {
            this.currentStep++;
        }
    }

    prevStep(): void {
        // Prevent going back to step 0 - once past step 0, user cannot return
        if (this.currentStep === 1) {
            // Cannot go back to step 0 - do nothing
            return;
        } else if (this.currentStep === 2) {
            // Going back to step 1 - fetch document master list and preview API
            this.currentStep = 1;
            this.modelLoader = true;
            this.fetchMasterDocumentListAndPreview();
        } else if (this.currentStep === 3) {
            // Going back to step 2 - call preview API to get latest data
            this.currentStep = 2;
            this.modelLoader = true;
            this.callBulkProductPreview();
        } else if (this.currentStep === 4) {
            // Going back to step 3 - call preview API to get latest data
            this.currentStep = 3;
            this.modelLoader = true;
            this.callBulkProductPreview();
        }
    }

    getModalTitle(): string {
        switch (this.currentStep) {
            case 0:
                return 'Bulk Upload - Upload Status';
            case 1:
                return 'Bulk Upload - Upload Documents';
            case 2:
                return 'Bulk Upload - Upload Images';
            case 3:
                return 'Bulk Upload - Preview';
            case 4:
                return 'Bulk Upload - Complete';
            default:
                return 'Bulk Upload';
        }
    }

    canProceedFromDocuments(): boolean {
        return true; // No documents are required
    }

    onVisibleChange(visible: boolean): void {
        // Sync visibility changes back to parent when modal closes
        // This handles cases where modal is closed via ESC key or clicking outside (mask)
        if (!visible) {
            // Modal is closing - close using Ionic ModalController
            const isCompleted = this.currentStep === 4;
            this.modalCtrl.dismiss(isCompleted);
        }
    }

    async handleCancel(): Promise<void> {
        if (this.tempBtnLoading || this.isUploading) {
            return;
        }

        // Determine if user has made progress
        const hasProgress = this.currentStep > 0 || this.uploadCompleted || 
                           (this.successfulProducts && this.successfulProducts.length > 0) ||
                           (this.previewResponseData && this.previewResponseData.data);

        // Use Ionic AlertController for confirmation instead of ng-zorro modal
        const alert = await this.alertController.create({
            header: 'Confirm Close',
            message: hasProgress 
                ? 'Are you sure you want to close?'
                : 'Are you sure you want to close the bulk upload modal?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing, just close the alert
                    }
                },
                {
                    text: 'Yes, Close',
                    cssClass: hasProgress ? 'alert-button-destructive' : '',
                    handler: () => {
                        // Always pass true to refresh list when modal closes (whether completed or cancelled)
                        const shouldRefresh = true;
                        this.resetModal();
                        // Close using Ionic ModalController - always pass true to refresh list
                        this.modalCtrl.dismiss(shouldRefresh);
                    }
                }
            ]
        });

        await alert.present();
    }

    resetModal(): void {
        this.currentStep = 0;
        this.selectedSubClass = null;
        this.selectedSubClassID = null;
        this.fileList1 = [];
        this.uploadResponseData = null;
        this.uploadCompleted = false;
        this.successfulProducts = [];
        this.isUploading = false;
        this.bulkAddResponseData = null;
        this.previewResponseData = null;
        this.jobId = null;
        this.errorFileUrl = null;
        this.productDocuments = {};
        this.productDocumentFileLists = {};
        this.documentUploading = {};
        this.productImageModes = {};
        this.productWebImages = {};
        this.productMobileImages = {};
        this.productVariationWebImages = {};
        this.productVariationMobileImages = {};
        this.productImageFileLists = {};
        this.imageUploading = {};
        this.productWebZipFiles = {};
        this.productMobileZipFiles = {};
        this.variationWebZipFiles = {};
        this.variationMobileZipFiles = {};
        this.documentStatusCache = {};
        this.expandedProductRows = {};
        this.expandedImageProductRows = {};
        this.expandedPreviewProductRows = {};
    }

    beforeUpload = (file: NzUploadFile): boolean => {
        const excelFormat = file.type === 'text/csv' || file.type === 'csv' || file.type.includes('vnd') || 
            file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        if (!excelFormat) {
            this.notification.error('Error', 'Please upload the excel file');
            return false;
        }
        const isLt2M = file.size! / 1024 / 1024 < 5;
        if (!isLt2M) {
            this.notification.error('Error', 'CSV must smaller than 5MB!');
            return false;
        }
        this.fileList1 = [];
        this.fileList1 = this.fileList1.concat(file);
        
        setTimeout(() => {
            this.checkAndAutoUpload();
        }, 100);
        
        return false;
    };

    checkAndAutoUpload(): void {
        if (this.isStep1Valid() && !this.uploadCompleted && !this.isUploading) {
            this.uploadProductFile();
        }
    }

    // ngx-file-drop methods (copied from mass-upload)
    public dropped(event: NgxFileDropEntry[]): void {
        this.progress = 1;
        const formData = new FormData();
        this.files = [event[0]];
        let fileTypes = ['csv', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
        
        for (const droppedFile of this.files) {
            // Is it a file?
            if (droppedFile.fileEntry.isFile && droppedFile['isprogress'] != 100) {
                const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
                const reader = new FileReader();
                fileEntry.file((file: File) => {
                    // Here you can access the real file
                    if (!fileTypes.includes(file.type)) {
                        this.toastService.displayToast('error.validExcel', null, 'danger');
                        this.selectedFile = null;
                        this.files = [];
                        this.fileList1 = [];
                        return;
                    }
                    this.selectedFile = file;
                    // Update fileList1 for compatibility
                    this.fileList1 = [{
                        uid: '-1',
                        name: file.name,
                        status: 'done',
                        url: '',
                        originFileObj: file
                    }];
                    
                    droppedFile['percentDone'] = "0%";
                    // Auto upload if subclass is selected
                    setTimeout(() => {
                        this.checkAndAutoUpload();
                    }, 100);
                    
                    droppedFile['fileSize'] = (file.size / 1048576).toFixed(2) + " MB";
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        droppedFile['filePath'] = reader.result;
                    };
                });
            } else {
                // It was a directory (empty directories are added, otherwise only files)
                const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
            }
        }
    }

    public fileOver(event: any): void {
        // Handle file over event if needed
    }

    public fileLeave(event: any): void {
        // Handle file leave event if needed
    }

    removeFile(index: number): void {
        if (this.files && this.files.length > index) {
            this.files.splice(index, 1);
        }
        this.selectedFile = null;
        this.fileList1 = [];
        this.progress = 0;
    }

    openFileSelector(): void {
        this.toastService.displayToast("Please select sub class first.", null, 'danger');
    }

    uploadProductFile(): void {
        if (this.isUploading) {
            return;
        }
        
        if (!this.selectedFile && (!this.fileList1 || this.fileList1.length === 0)) {
            this.notification.error('Error', 'Please upload a CSV file');
            return;
        }
        
        if (!this.selectedSubClassID) {
            this.notification.error('Error', 'Please select a Sub Class');
            return;
        }
        
        
        this.isUploading = true;
        this.tempBtnLoading = true;
        
        const formData = new FormData();
        
        // Use selectedFile from ngx-file-drop if available, otherwise use fileList1
        const file = this.selectedFile || (this.fileList1[0]?.originFileObj) || this.fileList1[0];
        if (file) {
            formData.append('productFile', file);
        } else {
            this.notification.error('Error', 'No file selected');
            this.isUploading = false;
            this.tempBtnLoading = false;
            return;
        }
        
        formData.append('sub_class_id', this.selectedSubClassID.toString());
        
        this.subscription.add(
            this.dataService.post(URLS.bulkUpload, formData).subscribe(
                (data) => {
                    if (data && data['code'] == 200) {
                        this.uploadResponseData = data;
                        this.uploadCompleted = true;
                        this.isUploading = false;
                        this.tempBtnLoading = false;
                        
                        // Extract job_id and file_url from response
                        if (data['data']) {
                            this.jobId = data['data']['job_id'] || null;
                            this.errorFileUrl = data['data']['file_url'] || null;
                        }
                        
                        if (this.uploadResponseData && this.uploadResponseData.data && this.uploadResponseData.data.successfulProducts) {
                            this.successfulProducts = this.uploadResponseData.data.successfulProducts;
                        }
                        
                        this.notification.success('Success', 'File uploaded successfully. Please review the status below.');
                    } else {
                        this.isUploading = false;
                        this.tempBtnLoading = false;
                        this.notification.error('Error', data['message'] || 'Failed to upload file. Please try again.');
                    }
                },
                (error) => {
                    this.isUploading = false;
                    this.tempBtnLoading = false;
                    this.notification.error('Error', error.error?.message || 'Failed to upload file. Please try again.');
                }
            )
        );
    }

    getFailedVariationsCount(variations: any[]): number {
        if (!variations || !Array.isArray(variations)) {
            return 0;
        }
        return variations.filter(v => v.status === 'failed').length;
    }

    // Document management methods
    initializeProductDocuments(): void {
        
        this.productDocuments = {};
        this.productDocumentFileLists = {};
        this.documentStatusCache = {};
        this.expandedProductRows = {};
        
        // Use previewResponse data directly - products are in previewResponse.data.products
        if (this.previewResponseData && this.previewResponseData.data && this.previewResponseData.data.products && Array.isArray(this.previewResponseData.data.products)) {
            
            this.previewResponseData.data.products.forEach((previewProduct: any, index: number) => {
                
                // Use product_id as the key (or product_code if available)
                const productKey = previewProduct.product_code || `product_${previewProduct.product_id}`;
                
                this.productDocuments[productKey] = {};
                this.productDocumentFileLists[productKey] = {};
                this.documentStatusCache[productKey] = {};
                this.expandedProductRows[productKey] = index === 0;
                
                // Initialize all document types first (set to null/empty)
                this.documentTypes.forEach(docType => {
                    this.productDocuments[productKey][docType.key] = null;
                    this.productDocumentFileLists[productKey][docType.key] = [];
                    this.documentStatusCache[productKey][docType.key] = false;
                });
                
                // Prefill documents from preview product if available
                if (previewProduct.documents && Array.isArray(previewProduct.documents)) {
                    
                    previewProduct.documents.forEach((previewDoc: any) => {
                        // Find matching document type by document_type_id
                        const docType = this.documentTypes.find(dt => dt.document_type_id === previewDoc.document_type_id);
                        
                        // Only prefill if document exists in preview and has actual document files
                        if (docType && previewDoc.documents && Array.isArray(previewDoc.documents) && previewDoc.documents.length > 0) {
                            const docFile = previewDoc.documents[0];
                            if (docFile.document_url) {
                                // Create file object for nz-upload
                                const fileName = docFile.document_name_en || docFile.document_name || 'document.pdf';
                                const fileObject: any = {
                                    uid: `prefilled-${docType.key}-${productKey}-${Date.now()}`,
                                    name: fileName,
                                    status: 'done',
                                    url: docFile.document_url,
                                    response: docFile,
                                    isPrefilled: true,
                                    document_url: docFile.document_url,
                                    document_type_id: previewDoc.document_type_id,
                                    thumbUrl: docFile.document_url,
                                    linkProps: {
                                        download: fileName
                                    }
                                };
                                
                                // Set document and file list
                                this.productDocuments[productKey][docType.key] = fileObject;
                                this.productDocumentFileLists[productKey][docType.key] = [fileObject];
                                this.documentStatusCache[productKey][docType.key] = true;
                                
                            }
                        }
                    });
                }
            });
        }
        
    }

    toggleProductRow(productCode: string): void {
        this.expandedProductRows[productCode] = !this.expandedProductRows[productCode];
    }

    isProductRowExpanded(productCode: string): boolean {
        return !!this.expandedProductRows[productCode];
    }

    getProductSummary(product: any): any {
        if (!product) {
            return {
                name: 'N/A',
                sku: 'N/A',
                price: 'N/A',
                warehouse: 'N/A',
                quantity: 'N/A',
                variationCount: 0
            };
        }
        
        // For preview products, create summary from preview data directly (no caching)
        if (product.product_id) {
            return {
                name: (this.commonService.domDirectionLTR ? product.product_name_en : product.product_name_ar) || product.product_name_en || product.product_name_ar || 'N/A',
                sku: product.product_sku || 'N/A',
                price: product.price_per_unit || 'N/A',
                warehouse: 'N/A',
                quantity: 'N/A',
                variationCount: product.sub_products?.length || 0
            };
        }
        
        // Fallback for other product structures
        return {
            name: (this.commonService.domDirectionLTR ? product.product_name_en : product.product_name_ar) || product.product_name_en || product.product_name_ar || 'N/A',
            sku: product.product_sku || 'N/A',
            price: product.price_per_unit || product.price || 'N/A',
            warehouse: 'N/A',
            quantity: 'N/A',
            variationCount: product.sub_products?.length || product.variations?.length || 0
        };
    }

    trackByProductCode(index: number, product: any): string {
        return product.product_code || index;
    }

    trackByProductId(index: number, product: any): string {
        return product.product_id?.toString() || product.product_code || index.toString();
    }

    trackByDocType(index: number, docType: any): string {
        return docType.key || index;
    }

    isDocumentUploaded(productCode: string, docType: string): boolean {
        // Check directly from productDocuments (no caching needed)
        return !!(this.productDocuments[productCode] && this.productDocuments[productCode][docType]);
    }

    isDocumentUploading(productCode: string, docType: string): boolean {
        return !!(this.documentUploading[productCode] && this.documentUploading[productCode][docType]);
    }

    getUploadedDocumentsCount(productCode: string): number {
        // Count directly from productDocuments (no caching needed)
        if (!this.productDocuments[productCode]) {
            return 0;
        }
        return Object.values(this.productDocuments[productCode]).filter(doc => doc !== null).length;
    }

    getRequiredDocumentsCount(): number {
        return 0; // No documents are required
    }

    getTotalRequiredDocuments(): number {
        const previewProducts = this.getPreviewProducts();
        if (!previewProducts || previewProducts.length === 0) {
            return 0;
        }
        // Total required = number of products × number of document types
        return previewProducts.length * (this.documentTypes.length || 0);
    }

    getUploadedRequiredDocumentsCount(): number {
        return 0; // No documents are required
    }

    getTotalUploadedDocumentsCount(): number {
        let count = 0;
        const previewProducts = this.getPreviewProducts();
        if (previewProducts && previewProducts.length > 0) {
            previewProducts.forEach(product => {
                count += this.getUploadedDocumentsCount(this.getProductKey(product));
            });
        }
        return count;
    }

    // Removed validateDocuments() - no documents are mandatory

    prepareDocumentsPayload(): any {
        const payload: any = {
            products: []
        };

        if (this.successfulProducts && this.successfulProducts.length > 0) {
            this.successfulProducts.forEach(product => {
                const productPayload: any = {
                    product_code: product.product_code,
                    documents: []
                };

                this.documentTypes.forEach(docType => {
                    if (this.isDocumentUploaded(product.product_code, docType.key)) {
                        const file = this.productDocuments[product.product_code][docType.key];
                        productPayload.documents.push({
                            document_type_id: docType.document_type_id,
                            document_type: docType.document_type_id.toString(),
                            document_name: docType.label,
                            document_name_ar: docType.label_ar,
                            file_name: file.name,
                            file_size: file.size,
                            file_type: file.type,
                            file: file,
                            is_required: docType.required
                        });
                    }
                });

                payload.products.push(productPayload);
            });
        }

        return payload;
    }

    getDocumentFileListRef(productCode: string, docType: string): any[] {
        if (!this.productDocumentFileLists[productCode]) {
            this.productDocumentFileLists[productCode] = {};
        }
        if (!this.productDocumentFileLists[productCode][docType]) {
            this.productDocumentFileLists[productCode][docType] = [];
        }
        
        // If document is prefilled but not in file list, add it
        if (this.productDocuments[productCode] && 
            this.productDocuments[productCode][docType] && 
            this.productDocumentFileLists[productCode][docType].length === 0) {
            this.productDocumentFileLists[productCode][docType] = [this.productDocuments[productCode][docType]];
        }
        
        return this.productDocumentFileLists[productCode][docType];
    }

    createBeforeUploadHandler(productCode: string, docType: string): (file: NzUploadFile) => boolean {
        return (file: NzUploadFile): boolean => {
            // Validate file type - only allow PDF, Word, CSV, and images
            const allowedTypes = [
                'application/pdf', // PDF
                'application/msword', // Word (.doc)
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word (.docx)
                'text/csv', // CSV
                'application/vnd.ms-excel', // Excel CSV
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel
                'image/jpeg', // JPEG
                'image/jpg', // JPG
                'image/png', // PNG
                'image/gif', // GIF
                'image/webp', // WebP
                'image/bmp' // BMP
            ];
            
            // Check file type
            const fileType = file.type || '';
            const fileName = file.name || '';
            const fileExtension = fileName.split('.').pop()?.toLowerCase() || '';
            
            // Validate by MIME type or file extension
            const isValidType = allowedTypes.some(type => fileType.includes(type)) ||
                ['pdf', 'doc', 'docx', 'csv', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(fileExtension);
            
            if (!isValidType) {
                this.notification.error('Error', 'Please upload only PDF, Word, CSV, or image files (JPG, PNG, GIF, WebP, BMP)');
                return false;
            }
            
            // Check file size (max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size && file.size > maxSize) {
                this.notification.error('Error', 'File size must be smaller than 10MB');
                return false;
            }
            
            // Upload document immediately
            this.uploadSingleDocument(productCode, docType, file);
            
            return false; // Prevent default upload behavior
        };
    }

    // Upload a single document
    uploadSingleDocument(productCode: string, docType: string, file: NzUploadFile): void {
        // Find the document type to get document_type_id
        const docTypeObj = this.documentTypes.find(dt => dt.key === docType);
        if (!docTypeObj) {
            this.notification.error('Error', 'Document type not found');
            return;
        }

        // Find the product to get product_id
        const previewProducts = this.getPreviewProducts();
        const product = previewProducts.find((p: any) => this.getProductKey(p) === productCode);
        if (!product || !product.product_id) {
            this.notification.error('Error', 'Product not found');
            return;
        }

        // Create FormData
        const formData = new FormData();
        formData.append('document_type_id', docTypeObj.document_type_id.toString());
        formData.append('product_id', product.product_id.toString());
        
        formData.append('document_name_en', docTypeObj.label || 'Document');
        formData.append('document_name_ar', docTypeObj.label_ar || docTypeObj.label || 'Document');
        formData.append('job_id', this.jobId.toString());
        
        // Append the file
        if (file.originFileObj) {
            formData.append('document_file', file.originFileObj);
        } else if (file as any instanceof File) {
            formData.append('document_file', file as any);
        } else {
            this.notification.error('Error', 'Invalid file object');
            return;
        }
        const formDataEntries: any = {};
        // Use type assertion to access entries() method
        const formDataWithEntries = formData as any;
        if (formDataWithEntries.entries) {
            for (const pair of formDataWithEntries.entries()) {
                if (pair[1] instanceof File) {
                    formDataEntries[pair[0]] = {
                        type: 'File',
                        name: pair[1].name,
                        size: pair[1].size,
                        mimeType: pair[1].type
                    };
                } else {
                    formDataEntries[pair[0]] = pair[1];
                }
            }
        }

        // Initialize state objects if needed
        if (!this.productDocuments[productCode]) {
            this.productDocuments[productCode] = {};
        }
        if (!this.productDocumentFileLists[productCode]) {
            this.productDocumentFileLists[productCode] = {};
        }
        if (!this.productDocumentFileLists[productCode][docType]) {
            this.productDocumentFileLists[productCode][docType] = [];
        }
        if (!this.documentUploading[productCode]) {
            this.documentUploading[productCode] = {};
        }
        if (!this.documentStatusCache[productCode]) {
            this.documentStatusCache[productCode] = {};
        }

        // Set uploading state to true
        this.documentUploading[productCode][docType] = true;
        
        // Add file to UI (with uploading status)
        const fileWithStatus = {
            ...file,
            status: 'uploading' as any
        };
        this.productDocuments[productCode][docType] = fileWithStatus;
        this.productDocumentFileLists[productCode][docType] = [fileWithStatus];

        // Call API to upload document
        this.subscription.add(
            this.dataService.post(URLS.addProductDocument, formData).subscribe(
                (response) => {
                    // Set uploading state to false
                    this.documentUploading[productCode][docType] = false;
                    
                    if (response && response.code === 200) {
                        this.notification.success('Success', 'Document uploaded successfully');
                        
                        // Update file status to done
                        const fileDone = {
                            ...file,
                            status: 'done' as any
                        };
                        this.productDocuments[productCode][docType] = fileDone;
                        this.productDocumentFileLists[productCode][docType] = [fileDone];
                        if (!this.documentStatusCache[productCode]) {
                            this.documentStatusCache[productCode] = {};
                        }
                        this.documentStatusCache[productCode][docType] = true;
                        
                        // After successful upload, call preview API to refresh data
                        this.callBulkProductPreview();
                    } else {
                        this.notification.error('Error', response.message || 'Failed to upload document');
                        // Remove file on error
                        this.productDocuments[productCode][docType] = null;
                        this.productDocumentFileLists[productCode][docType] = [];
                        if (this.documentStatusCache[productCode]) {
                            this.documentStatusCache[productCode][docType] = false;
                        }
                    }
                },
                (error) => {
                    console.error('Document upload error:', error);
                    // Set uploading state to false
                    this.documentUploading[productCode][docType] = false;
                    
                    this.notification.error('Error', error.error?.message || 'Failed to upload document');
                    // Remove file on error
                    this.productDocuments[productCode][docType] = null;
                    this.productDocumentFileLists[productCode][docType] = [];
                    if (this.documentStatusCache[productCode]) {
                        this.documentStatusCache[productCode][docType] = false;
                    }
                }
            )
        );
    }

    createRemoveHandler(productCode: string, docType: string): (file: NzUploadFile) => boolean {
        return (file: NzUploadFile): boolean => {
            if (this.productDocuments[productCode]) {
                this.productDocuments[productCode][docType] = null;
            }
            if (this.productDocumentFileLists[productCode] && this.productDocumentFileLists[productCode][docType]) {
                this.productDocumentFileLists[productCode][docType] = [];
            }
            if (this.documentStatusCache[productCode]) {
                this.documentStatusCache[productCode][docType] = false;
            }
            return true;
        };
    }

    // Image management methods
    initializeProductImages(): void {
        this.productImageModes = {};
        this.productWebImages = {};
        this.productMobileImages = {};
        this.productVariationWebImages = {};
        this.productVariationMobileImages = {};
        this.productImageFileLists = {};
        this.imageUploading = {};
        this.expandedImageProductRows = {};
        
        // Use previewResponse data directly - products are in previewResponse.data.products
        if (this.previewResponseData && this.previewResponseData.data && this.previewResponseData.data.products && Array.isArray(this.previewResponseData.data.products)) {
            
            this.previewResponseData.data.products.forEach((previewProduct: any, index: number) => {
                
                const productKey = previewProduct.product_code || `product_${previewProduct.product_id}`;
                
                // Set image mode from preview
                const imageMode: 'common' | 'unique' = previewProduct.is_common_images_to_all_sku ? 'common' : 'unique';
                this.productImageModes[productKey] = imageMode;                
                // Initialize image arrays
                this.productWebImages[productKey] = [];
                this.productMobileImages[productKey] = [];
                this.productVariationWebImages[productKey] = {};
                this.productVariationMobileImages[productKey] = {};
                this.imageUploading[productKey] = { web: false, mobile: false };
                this.expandedImageProductRows[productKey] = index === 0;
                
                // Process product-level images (common images)
                if (previewProduct.product_images && Array.isArray(previewProduct.product_images)) {
                    previewProduct.product_images.forEach((imgGroup: any) => {
                        // Process web images
                        if (imgGroup.web_images && Array.isArray(imgGroup.web_images)) {
                            this.productWebImages[productKey] = imgGroup.web_images.map((img: any, imgIndex: number) => {
                                return {
                                    uid: `prefilled-web-${productKey}-${imgIndex}-${Date.now()}`,
                                    name: `web-image-${imgIndex}.jpg`,
                                    status: 'done' as any,
                                    url: img.image_url,
                                    thumbUrl: img.image_url,
                                    response: img,
                                    isPrefilled: true,
                                    image_url: img.image_url,
                                    image_id: img.image_id,
                                    is_cover_image: img.is_cover_image || img.is_cover_images || false,
                                    image_type: 'web'
                                };
                            });
                        }
                        
                        // Process mobile images
                        if (imgGroup.mobile_images && Array.isArray(imgGroup.mobile_images)) {
                            this.productMobileImages[productKey] = imgGroup.mobile_images.map((img: any, imgIndex: number) => {
                                return {
                                    uid: `prefilled-mobile-${productKey}-${imgIndex}-${Date.now()}`,
                                    name: `mobile-image-${imgIndex}.jpg`,
                                    status: 'done' as any,
                                    url: img.image_url,
                                    thumbUrl: img.image_url,
                                    response: img,
                                    isPrefilled: true,
                                    image_url: img.image_url,
                                    image_id: img.image_id,
                                    is_cover_image: img.is_cover_image || img.is_cover_images || false,
                                    image_type: 'mobile'
                                };
                            });
                        }
                    });
                }
                
                // Process variation-level images (if unique mode)
                if (imageMode === 'unique' && previewProduct.sub_products && Array.isArray(previewProduct.sub_products)) {
                    previewProduct.sub_products.forEach((subProduct: any) => {
                        const variationKey = `${productKey}_${subProduct.product_sku}`;
                        this.productVariationWebImages[productKey][variationKey] = [];
                        this.productVariationMobileImages[productKey][variationKey] = [];
                        
                        if (subProduct.product_images && Array.isArray(subProduct.product_images)) {
                            subProduct.product_images.forEach((imgGroup: any) => {
                                // Process web images
                                if (imgGroup.web_images && Array.isArray(imgGroup.web_images)) {
                                    this.productVariationWebImages[productKey][variationKey] = imgGroup.web_images.map((img: any, imgIndex: number) => {
                                        return {
                                            uid: `prefilled-variation-web-${variationKey}-${imgIndex}-${Date.now()}`,
                                            name: `web-image-${imgIndex}.jpg`,
                                            status: 'done' as any,
                                            url: img.image_url,
                                            thumbUrl: img.image_url,
                                            response: img,
                                            isPrefilled: true,
                                            image_url: img.image_url,
                                            image_id: img.image_id,
                                            is_cover_image: img.is_cover_image || img.is_cover_images || false,
                                            image_type: 'web'
                                        };
                                    });
                                }
                                
                                // Process mobile images
                                if (imgGroup.mobile_images && Array.isArray(imgGroup.mobile_images)) {
                                    this.productVariationMobileImages[productKey][variationKey] = imgGroup.mobile_images.map((img: any, imgIndex: number) => {
                                        return {
                                            uid: `prefilled-variation-mobile-${variationKey}-${imgIndex}-${Date.now()}`,
                                            name: `mobile-image-${imgIndex}.jpg`,
                                            status: 'done' as any,
                                            url: img.image_url,
                                            thumbUrl: img.image_url,
                                            response: img,
                                            isPrefilled: true,
                                            image_url: img.image_url,
                                            image_id: img.image_id,
                                            is_cover_image: img.is_cover_image || img.is_cover_images || false,
                                            image_type: 'mobile'
                                        };
                                    });
                                }
                            });
                        }
                    });
                }
                
                // Initialize file lists for nz-upload
                this.productImageFileLists[productKey] = {
                    web: this.productWebImages[productKey] || [],
                    mobile: this.productMobileImages[productKey] || [],
                    variations: {}
                };
                
            });
        } else {
            console.error('Preview response not available or invalid structure for images');
        }
    }
    toggleImageProductRow(productCode: string): void {
        this.expandedImageProductRows[productCode] = !this.expandedImageProductRows[productCode];
    }

    isImageProductRowExpanded(productCode: string): boolean {
        return !!this.expandedImageProductRows[productCode];
    }

    getVariationKey(variation: any, productCode?: string): string {
        // Use product_sku as the key for variations (from preview response sub_products)
        if (variation.product_sku) {
            return productCode ? `${productCode}_${variation.product_sku}` : variation.product_sku;
        }
        // Fallback
        return variation.product_code ? `${variation.product_code}_${variation.product_sku}` : 'variation';
    }

    setImageMode(productCode: string, mode: 'common' | 'unique'): void {
        const previousMode = this.productImageModes[productCode];
        
        // Only reset if mode is actually changing
        if (previousMode && previousMode !== mode) {
            // Check if any images were uploaded before showing the message
            const hasProductImages = (this.productWebImages[productCode] && this.productWebImages[productCode].length > 0) ||
                                     (this.productMobileImages[productCode] && this.productMobileImages[productCode].length > 0);
            
            const hasVariationImages = this.productVariationWebImages[productCode] && Object.keys(this.productVariationWebImages[productCode]).length > 0 ||
                                     this.productVariationMobileImages[productCode] && Object.keys(this.productVariationMobileImages[productCode]).length > 0;
            
            const hasZipFiles = this.productWebZipFiles[productCode] || this.productMobileZipFiles[productCode] ||
                               (this.variationWebZipFiles[productCode] && Object.keys(this.variationWebZipFiles[productCode]).length > 0) ||
                               (this.variationMobileZipFiles[productCode] && Object.keys(this.variationMobileZipFiles[productCode]).length > 0);
            
            const hasAnyImages = hasProductImages || hasVariationImages || hasZipFiles;
            
            // Reset product-level images
            if (this.productWebImages[productCode]) {
                this.productWebImages[productCode] = [];
            }
            if (this.productMobileImages[productCode]) {
                this.productMobileImages[productCode] = [];
            }
            
            // Reset variation-level images
            if (this.productVariationWebImages[productCode]) {
                this.productVariationWebImages[productCode] = {};
            }
            if (this.productVariationMobileImages[productCode]) {
                this.productVariationMobileImages[productCode] = {};
            }
            
            // Reset ZIP files
            if (this.productWebZipFiles[productCode]) {
                delete this.productWebZipFiles[productCode];
            }
            if (this.productMobileZipFiles[productCode]) {
                delete this.productMobileZipFiles[productCode];
            }
            
            // Reset variation ZIP files
            if (this.variationWebZipFiles[productCode]) {
                delete this.variationWebZipFiles[productCode];
            }
            if (this.variationMobileZipFiles[productCode]) {
                delete this.variationMobileZipFiles[productCode];
            }
            
            // Reset file lists
            if (this.productImageFileLists[productCode]) {
                this.productImageFileLists[productCode] = {
                    web: [],
                    mobile: [],
                    variations: {}
                };
            }
            
            // Show notification only if images were uploaded
            if (hasAnyImages) {
                this.notification.info('Info', `Image mode changed to ${mode === 'common' ? 'Common for all' : 'Unique for all'}. Images have been reset. Please upload images again.`);
            }
        }
        
        // Set the new mode
        this.productImageModes[productCode] = mode;
    }

    getImageMode(productCode: string): 'common' | 'unique' {
        return this.productImageModes[productCode] || 'common';
    }

    getCommonImagesFileList(productCode: string): any[] {
        if (!this.productImageFileLists[productCode]) {
            this.productImageFileLists[productCode] = { common: [], variations: {} };
        }
        if (!this.productImageFileLists[productCode].common) {
            this.productImageFileLists[productCode].common = [];
        }
        return this.productImageFileLists[productCode].common;
    }

    getVariationImagesFileList(productCode: string, variationKey: string): any[] {
        if (!this.productImageFileLists[productCode]) {
            this.productImageFileLists[productCode] = { common: [], variations: {} };
        }
        if (!this.productImageFileLists[productCode].variations) {
            this.productImageFileLists[productCode].variations = {};
        }
        if (!this.productImageFileLists[productCode].variations[variationKey]) {
            this.productImageFileLists[productCode].variations[variationKey] = [];
        }
        return this.productImageFileLists[productCode].variations[variationKey];
    }

    // Create zip upload handler for web images - stores file for later upload
    createWebImageZipUploadHandler(productCode: string): (file: NzUploadFile) => boolean {
        return (file: NzUploadFile): boolean => {
            // Validate zip file
            const fileName = file.name || '';
            const fileExtension = fileName.split('.').pop()?.toLowerCase() || '';
            const isZip = fileExtension === 'zip' || file.type === 'application/zip' || file.type === 'application/x-zip-compressed';
            
            if (!isZip) {
                this.notification.error('Error', 'Please upload a ZIP file');
                return false;
            }
            
            // Check file size (max 50MB for zip)
            const maxSize = 50 * 1024 * 1024; // 50MB
            if (file.size && file.size > maxSize) {
                this.notification.error('Error', 'ZIP file size must be smaller than 50MB');
                return false;
            }
            
            // Store file for later upload
            this.productWebZipFiles[productCode] = file;
            this.notification.success('Success', 'Web ZIP file added. Click Upload to upload both files.');
            
            return false; // Prevent default upload behavior
        };
    }

    // Create zip upload handler for mobile images - stores file for later upload
    createMobileImageZipUploadHandler(productCode: string): (file: NzUploadFile) => boolean {
        return (file: NzUploadFile): boolean => {
            // Validate zip file
            const fileName = file.name || '';
            const fileExtension = fileName.split('.').pop()?.toLowerCase() || '';
            const isZip = fileExtension === 'zip' || file.type === 'application/zip' || file.type === 'application/x-zip-compressed';
            
            if (!isZip) {
                this.notification.error('Error', 'Please upload a ZIP file');
                return false;
            }
            
            // Check file size (max 50MB for zip)
            const maxSize = 50 * 1024 * 1024; // 50MB
            if (file.size && file.size > maxSize) {
                this.notification.error('Error', 'ZIP file size must be smaller than 50MB');
                return false;
            }
            
            // Store file for later upload
            this.productMobileZipFiles[productCode] = file;
            this.notification.success('Success', 'Mobile ZIP file added. Click Upload to upload both files.');
            
            return false; // Prevent default upload behavior
        };
    }

    // Upload variation image zip file (web or mobile)
    uploadVariationImageZip(productCode: string, variationKey: string, imageType: 'web' | 'mobile', file: NzUploadFile): void {
        // Initialize upload tracking
        if (!this.imageUploading[productCode]) {
            this.imageUploading[productCode] = { web: false, mobile: false, variations: {} };
        }
        if (!this.imageUploading[productCode].variations) {
            this.imageUploading[productCode].variations = {};
        }
        if (!this.imageUploading[productCode].variations[variationKey]) {
            this.imageUploading[productCode].variations[variationKey] = { web: false, mobile: false };
        }
        
        // Set uploading state
        this.imageUploading[productCode].variations[variationKey][imageType] = true;
        
        // Find the product to get product_id
        const previewProducts = this.getPreviewProducts();
        const product = previewProducts.find((p: any) => this.getProductKey(p) === productCode);
        
        if (!product || !product.product_id) {
            this.notification.error('Error', 'Product not found');
            this.imageUploading[productCode].variations[variationKey][imageType] = false;
            return;
        }
        
        // Create FormData
        const formData = new FormData();
        formData.append('product_id', product.product_id.toString());
        formData.append('is_common_images_to_all_sku', 'false'); // Variations use unique images

        
        // Add job_id if available
        if (this.jobId) {
            formData.append('job_id', this.jobId.toString());
        }
        
        // Add the appropriate zip file
        if (file.originFileObj) {
            if (imageType === 'web') {
                formData.append('web_image_zip', file.originFileObj);
            } else {
                formData.append('mobile_image_zip', file.originFileObj);
            }
        } else if (file as any instanceof File) {
            if (imageType === 'web') {
                formData.append('web_image_zip', file as any);
            } else {
                formData.append('mobile_image_zip', file as any);
            }
        } else {
            this.notification.error('Error', 'Invalid file object');
            this.imageUploading[productCode].variations[variationKey][imageType] = false;
            return;
        }
        
        // Call upload API
        this.subscription.add(
            this.dataService.post(URLS.bulkProductImagesUpload, formData).subscribe(
                (response) => {
                    this.imageUploading[productCode].variations[variationKey][imageType] = false;
                    
                    if (response && response.code === 200) {
                        this.notification.success('Success', `${imageType === 'web' ? 'Web' : 'Mobile'} images uploaded successfully`);
                        
                        // Refresh preview data to get updated images with loader
                        this.modelLoader = true;
                        this.callBulkProductPreview();
                    } else {
                        this.notification.error('Error', response.message || 'Failed to upload images');
                    }
                },
                (error) => {
                    this.imageUploading[productCode].variations[variationKey][imageType] = false;
                    this.notification.error('Error', `Failed to upload ${imageType === 'web' ? 'web' : 'mobile'} images: ${error.message || 'Unknown error'}`);
                }
            )
        );
    }

    // Upload image zip file (web or mobile) - for product level
    uploadImageZip(productCode: string, imageType: 'web' | 'mobile', file: NzUploadFile): void {
        // Find the product to get product_id
        const previewProducts = this.getPreviewProducts();
        const product = previewProducts.find((p: any) => this.getProductKey(p) === productCode);
        if (!product || !product.product_id) {
            this.notification.error('Error', 'Product not found');
            return;
        }

        // Get is_common_images_to_all_sku from image mode
        const isCommonMode = this.getImageMode(productCode) === 'common';

        // Initialize state
        if (!this.imageUploading[productCode]) {
            this.imageUploading[productCode] = { web: false, mobile: false, variations: {} };
        }
        if (!this.productImageFileLists[productCode]) {
            this.productImageFileLists[productCode] = { web: [], mobile: [], variations: {} };
        }

        // Set uploading state
        this.imageUploading[productCode][imageType] = true;

        // Create FormData
        const formData = new FormData();
        formData.append('product_id', product.product_id.toString());
        formData.append('is_common_images_to_all_sku', isCommonMode.toString());
        
        // Add job_id if available
        if (this.jobId) {
            formData.append('job_id', this.jobId.toString());
        }
        
        // Append the zip file based on type
        if (file.originFileObj) {
            if (imageType === 'web') {
                formData.append('web_image_zip', file.originFileObj);
            } else {
                formData.append('mobile_image_zip', file.originFileObj);
            }
        } else if (file as any instanceof File) {
            if (imageType === 'web') {
                formData.append('web_image_zip', file as any);
            } else {
                formData.append('mobile_image_zip', file as any);
            }
        } else {
            this.notification.error('Error', 'Invalid file object');
            this.imageUploading[productCode][imageType] = false;
            return;
        }

        // Call API to upload zip
        this.subscription.add(
            this.dataService.post(URLS.bulkProductImagesUpload, formData).subscribe(
                (response) => {
                    this.imageUploading[productCode][imageType] = false;
                    
                    if (response && response.code === 200) {
                        this.notification.success('Success', `${imageType === 'web' ? 'Web' : 'Mobile'} images uploaded successfully`);
                        
                        // After successful upload, call preview API to refresh data and get individual images with loader
                        this.modelLoader = true;
                        this.callBulkProductPreview();
                    } else {
                        this.notification.error('Error', response.message || 'Failed to upload images');
                    }
                },
                (error) => {
                    console.error('Image zip upload error:', error);
                    this.imageUploading[productCode][imageType] = false;
                    this.modelLoader = false;
                    this.notification.error('Error', error.error?.message || 'Failed to upload images');
                }
            )
        );
    }

    // Upload both web and mobile ZIP files together
    uploadProductImagesZip(productCode: string): void {
        const webFile = this.productWebZipFiles[productCode];
        const mobileFile = this.productMobileZipFiles[productCode];
        
        // Check if both files are selected (both web and mobile are required)
        if (!webFile || !mobileFile) {
            this.notification.error('Error', 'Please add both Web and Mobile ZIP files before uploading');
            return;
        }
        
        // Find the product to get product_id
        const previewProducts = this.getPreviewProducts();
        const product = previewProducts.find((p: any) => this.getProductKey(p) === productCode);
        if (!product || !product.product_id) {
            this.notification.error('Error', 'Product not found');
            return;
        }

        // Get is_common_images_to_all_sku from image mode
        const isCommonMode = this.getImageMode(productCode) === 'common';

        // Initialize state
        if (!this.imageUploading[productCode]) {
            this.imageUploading[productCode] = { web: false, mobile: false, variations: {} };
        }
        
        // Set uploading state
        this.imageUploading[productCode].web = true;
        this.imageUploading[productCode].mobile = true;

        // Create FormData
        const formData = new FormData();
        formData.append('product_id', product.product_id.toString());
        formData.append('is_common_images_to_all_sku', isCommonMode.toString());

        
        // Add job_id if available
        if (this.jobId) {
            formData.append('job_id', this.jobId.toString());
        }
        
        // Append web ZIP file if available
        if (webFile) {
            if (webFile.originFileObj) {
                formData.append('web_image_zip', webFile.originFileObj);
            } else if (webFile as any instanceof File) {
                formData.append('web_image_zip', webFile as any);
            }
        }
        
        // Append mobile ZIP file if available
        if (mobileFile) {
            if (mobileFile.originFileObj) {
                formData.append('mobile_image_zip', mobileFile.originFileObj);
            } else if (mobileFile as any instanceof File) {
                formData.append('mobile_image_zip', mobileFile as any);
            }
        }

        // Call API to upload both ZIP files
        this.subscription.add(
            this.dataService.post(URLS.bulkProductImagesUpload, formData).subscribe(
                (response) => {
                    this.imageUploading[productCode].web = false;
                    this.imageUploading[productCode].mobile = false;
                    
                    if (response && response.code === 200) {
                        this.notification.success('Success', 'Images uploaded successfully');
                        
                        // Clear stored files after successful upload
                        delete this.productWebZipFiles[productCode];
                        delete this.productMobileZipFiles[productCode];
                        
                        // After successful upload, call preview API to refresh data and get individual images with loader
                        this.modelLoader = true;
                        this.callBulkProductPreview();
                    } else {
                        this.notification.error('Error', response.message || 'Failed to upload images');
                    }
                },
                (error) => {
                    this.imageUploading[productCode].web = false;
                    this.imageUploading[productCode].mobile = false;
                    this.modelLoader = false;
                    this.notification.error('Error', error.error?.message || 'Failed to upload images');
                }
            )
        );
    }
    
    // Check if web ZIP file is selected
    hasWebZipFile(productCode: string): boolean {
        return !!this.productWebZipFiles[productCode];
    }
    
    // Check if mobile ZIP file is selected
    hasMobileZipFile(productCode: string): boolean {
        return !!this.productMobileZipFiles[productCode];
    }
    
    // Check if both ZIP files are selected (both web and mobile are required)
    hasAnyZipFile(productCode: string): boolean {
        return this.hasWebZipFile(productCode) && this.hasMobileZipFile(productCode);
    }
    
    // Get web ZIP file name
    getWebZipFileName(productCode: string): string {
        const file = this.productWebZipFiles[productCode];
        return file ? (file.name || 'Unknown') : '';
    }
    
    // Get mobile ZIP file name
    getMobileZipFileName(productCode: string): string {
        const file = this.productMobileZipFiles[productCode];
        return file ? (file.name || 'Unknown') : '';
    }

    // Check if web images are uploading
    isWebImageUploading(productCode: string): boolean {
        return !!(this.imageUploading[productCode] && this.imageUploading[productCode].web);
    }

    // Check if mobile images are uploading
    isMobileImageUploading(productCode: string): boolean {
        return !!(this.imageUploading[productCode] && this.imageUploading[productCode].mobile);
    }
    
    // Check if images are uploading (either web or mobile)
    isImageUploading(productCode: string): boolean {
        return this.isWebImageUploading(productCode) || this.isMobileImageUploading(productCode);
    }

    // Check if variation web image is uploading
    isVariationWebImageUploading(productCode: string, variationKey: string): boolean {
        if (!this.imageUploading[productCode]) {
            return false;
        }
        if (!this.imageUploading[productCode].variations) {
            return false;
        }
        return !!(this.imageUploading[productCode].variations[variationKey] && this.imageUploading[productCode].variations[variationKey].web);
    }

    // Check if variation mobile image is uploading
    isVariationMobileImageUploading(productCode: string, variationKey: string): boolean {
        if (!this.imageUploading[productCode]) {
            return false;
        }
        if (!this.imageUploading[productCode].variations) {
            return false;
        }
        return !!(this.imageUploading[productCode].variations[variationKey] && this.imageUploading[productCode].variations[variationKey].mobile);
    }

    // Get web images file list
    getWebImagesFileList(productCode: string): any[] {
        if (!this.productImageFileLists[productCode]) {
            this.productImageFileLists[productCode] = { web: [], mobile: [], variations: {} };
        }
        return this.productImageFileLists[productCode].web || [];
    }

    // Get mobile images file list
    getMobileImagesFileList(productCode: string): any[] {
        if (!this.productImageFileLists[productCode]) {
            this.productImageFileLists[productCode] = { web: [], mobile: [], variations: {} };
        }
        return this.productImageFileLists[productCode].mobile || [];
    }

    // Check if web images are uploaded
    hasWebImagesUploaded(productCode: string): boolean {
        return !!(this.productWebImages[productCode] && this.productWebImages[productCode].length > 0);
    }

    // Check if mobile images are uploaded
    hasMobileImagesUploaded(productCode: string): boolean {
        return !!(this.productMobileImages[productCode] && this.productMobileImages[productCode].length > 0);
    }

    // Check if web images have cover image
    hasWebCoverImage(productCode: string): boolean {
        if (!this.productWebImages[productCode] || !Array.isArray(this.productWebImages[productCode])) {
            return false;
        }
        return this.productWebImages[productCode].some((img: any) => img.is_cover_image || img.is_cover_images);
    }

    // Check if mobile images have cover image
    hasMobileCoverImage(productCode: string): boolean {
        if (!this.productMobileImages[productCode] || !Array.isArray(this.productMobileImages[productCode])) {
            return false;
        }
        return this.productMobileImages[productCode].some((img: any) => img.is_cover_image || img.is_cover_images);
    }

    // Create zip upload handler for variation web images - stores file for later upload
    createVariationWebImageZipUploadHandler(productCode: string, variationSku: string): (file: NzUploadFile) => boolean {
        return (file: NzUploadFile): boolean => {
            // Validate zip file
            const fileName = file.name || '';
            const fileExtension = fileName.split('.').pop()?.toLowerCase() || '';
            const isZip = fileExtension === 'zip' || file.type === 'application/zip' || file.type === 'application/x-zip-compressed';
            
            if (!isZip) {
                this.notification.error('Error', 'Please upload a ZIP file');
                return false;
            }
            
            const maxSize = 50 * 1024 * 1024; // 50MB
            if (file.size && file.size > maxSize) {
                this.notification.error('Error', 'ZIP file size must be smaller than 50MB');
                return false;
            }
            
            // Store file for later upload
            const variationKey = `${productCode}_${variationSku}`;
            if (!this.variationWebZipFiles[productCode]) {
                this.variationWebZipFiles[productCode] = {};
            }
            this.variationWebZipFiles[productCode][variationKey] = file;
            this.notification.success('Success', 'Web ZIP file added. Click Upload to upload both files.');
            
            return false;
        };
    }

    // Create zip upload handler for variation mobile images - stores file for later upload
    createVariationMobileImageZipUploadHandler(productCode: string, variationSku: string): (file: NzUploadFile) => boolean {
        return (file: NzUploadFile): boolean => {
            // Validate zip file
            const fileName = file.name || '';
            const fileExtension = fileName.split('.').pop()?.toLowerCase() || '';
            const isZip = fileExtension === 'zip' || file.type === 'application/zip' || file.type === 'application/x-zip-compressed';
            
            if (!isZip) {
                this.notification.error('Error', 'Please upload a ZIP file');
                return false;
            }
            
            const maxSize = 50 * 1024 * 1024; // 50MB
            if (file.size && file.size > maxSize) {
                this.notification.error('Error', 'ZIP file size must be smaller than 50MB');
                return false;
            }
            
            // Store file for later upload
            const variationKey = `${productCode}_${variationSku}`;
            if (!this.variationMobileZipFiles[productCode]) {
                this.variationMobileZipFiles[productCode] = {};
            }
            this.variationMobileZipFiles[productCode][variationKey] = file;
            this.notification.success('Success', 'Mobile ZIP file added. Click Upload to upload both files.');
            
            return false;
        };
    }
    
    // Upload both web and mobile ZIP files for variation together
    uploadVariationImagesZip(productCode: string, variationKey: string): void {
        const webFile = this.variationWebZipFiles[productCode]?.[variationKey];
        const mobileFile = this.variationMobileZipFiles[productCode]?.[variationKey];
        
        // Check if both files are selected (both web and mobile are required)
        if (!webFile || !mobileFile) {
            this.notification.error('Error', 'Please add both Web and Mobile ZIP files before uploading');
            return;
        }
        
        // Find the product and variation to get variation's product_id
        const previewProducts = this.getPreviewProducts();
        const product = previewProducts.find((p: any) => this.getProductKey(p) === productCode);
        if (!product || !product.product_id) {
            this.notification.error('Error', 'Product not found');
            return;
        }
        
        // Extract variation SKU from variationKey (format: productCode_variationSku)
        const variationSku = variationKey.replace(`${productCode}_`, '');
        
        // Find the specific variation (sub_product) from the product's sub_products array
        const variation = product.sub_products?.find((sub: any) => sub.product_sku === variationSku);
        if (!variation || !variation.product_id) {
            this.notification.error('Error', 'Variation not found');
            return;
        }

        // Initialize upload tracking
        if (!this.imageUploading[productCode]) {
            this.imageUploading[productCode] = { web: false, mobile: false, variations: {} };
        }
        if (!this.imageUploading[productCode].variations) {
            this.imageUploading[productCode].variations = {};
        }
        if (!this.imageUploading[productCode].variations[variationKey]) {
            this.imageUploading[productCode].variations[variationKey] = { web: false, mobile: false };
        }
        
        // Set uploading state
        this.imageUploading[productCode].variations[variationKey].web = true;
        this.imageUploading[productCode].variations[variationKey].mobile = true;

        // Create FormData - use variation's product_id (not parent product_id)
        const formData = new FormData();
        formData.append('product_id', variation.product_id.toString());
        formData.append('is_common_images_to_all_sku', 'false'); // Variations use unique images
        
        // Add job_id if available
        if (this.jobId) {
            formData.append('job_id', this.jobId.toString());
        }
        
        // Append web ZIP file if available
        if (webFile) {
            if (webFile.originFileObj) {
                formData.append('web_image_zip', webFile.originFileObj);
            } else if (webFile as any instanceof File) {
                formData.append('web_image_zip', webFile as any);
            }
        }
        
        // Append mobile ZIP file if available
        if (mobileFile) {
            if (mobileFile.originFileObj) {
                formData.append('mobile_image_zip', mobileFile.originFileObj);
            } else if (mobileFile as any instanceof File) {
                formData.append('mobile_image_zip', mobileFile as any);
            }
        }

        // Call API to upload both ZIP files
        this.subscription.add(
            this.dataService.post(URLS.bulkProductImagesUpload, formData).subscribe(
                (response) => {
                    this.imageUploading[productCode].variations[variationKey].web = false;
                    this.imageUploading[productCode].variations[variationKey].mobile = false;
                    
                    if (response && response.code === 200) {
                        this.notification.success('Success', 'Images uploaded successfully');
                        
                        // Clear stored files after successful upload
                        if (this.variationWebZipFiles[productCode]) {
                            delete this.variationWebZipFiles[productCode][variationKey];
                        }
                        if (this.variationMobileZipFiles[productCode]) {
                            delete this.variationMobileZipFiles[productCode][variationKey];
                        }
                        
                        // After successful upload, call preview API to refresh data and get individual images with loader
                        this.modelLoader = true;
                        this.callBulkProductPreview();
                    } else {
                        this.notification.error('Error', response.message || 'Failed to upload images');
                    }
                },
                (error) => {
                    this.imageUploading[productCode].variations[variationKey].web = false;
                    this.imageUploading[productCode].variations[variationKey].mobile = false;
                    this.modelLoader = false;
                    this.notification.error('Error', error.error?.message || 'Failed to upload images');
                }
            )
        );
    }
    
    // Check if variation web ZIP file is selected
    hasVariationWebZipFile(productCode: string, variationKey: string): boolean {
        return !!(this.variationWebZipFiles[productCode] && this.variationWebZipFiles[productCode][variationKey]);
    }
    
    // Check if variation mobile ZIP file is selected
    hasVariationMobileZipFile(productCode: string, variationKey: string): boolean {
        return !!(this.variationMobileZipFiles[productCode] && this.variationMobileZipFiles[productCode][variationKey]);
    }
    
    // Check if both ZIP files are selected for variation (both web and mobile are required)
    hasAnyVariationZipFile(productCode: string, variationKey: string): boolean {
        return this.hasVariationWebZipFile(productCode, variationKey) && this.hasVariationMobileZipFile(productCode, variationKey);
    }
    
    // Get variation web ZIP file name
    getVariationWebZipFileName(productCode: string, variationKey: string): string {
        const file = this.variationWebZipFiles[productCode]?.[variationKey];
        return file ? (file.name || 'Unknown') : '';
    }
    
    // Get variation mobile ZIP file name
    getVariationMobileZipFileName(productCode: string, variationKey: string): string {
        const file = this.variationMobileZipFiles[productCode]?.[variationKey];
        return file ? (file.name || 'Unknown') : '';
    }
    
    // Check if variation images are uploading
    isVariationImageUploading(productCode: string, variationKey: string): boolean {
        return this.isVariationWebImageUploading(productCode, variationKey) || this.isVariationMobileImageUploading(productCode, variationKey);
    }

    // Get variation web images file list
    getVariationWebImagesFileList(productCode: string, variationKey: string): any[] {
        if (!this.productVariationWebImages[productCode]) {
            this.productVariationWebImages[productCode] = {};
        }
        return this.productVariationWebImages[productCode][variationKey] || [];
    }

    // Get variation mobile images file list
    getVariationMobileImagesFileList(productCode: string, variationKey: string): any[] {
        if (!this.productVariationMobileImages[productCode]) {
            this.productVariationMobileImages[productCode] = {};
        }
        return this.productVariationMobileImages[productCode][variationKey] || [];
    }

    // Get first product image URL for thumbnail
    getFirstProductImage(productCode: string): string {
        if (this.productWebImages[productCode] && this.productWebImages[productCode].length > 0) {
            return this.productWebImages[productCode][0].image_url || this.productWebImages[productCode][0].url || '';
        }
        if (this.productMobileImages[productCode] && this.productMobileImages[productCode].length > 0) {
            return this.productMobileImages[productCode][0].image_url || this.productMobileImages[productCode][0].url || '';
        }
        return '';
    }

    // Get first variation image URL for thumbnail
    getFirstVariationImage(productCode: string, variationKey: string): string {
        if (this.productVariationWebImages[productCode] && this.productVariationWebImages[productCode][variationKey] && 
            this.productVariationWebImages[productCode][variationKey].length > 0) {
            return this.productVariationWebImages[productCode][variationKey][0].image_url || 
                   this.productVariationWebImages[productCode][variationKey][0].url || '';
        }
        if (this.productVariationMobileImages[productCode] && this.productVariationMobileImages[productCode][variationKey] && 
            this.productVariationMobileImages[productCode][variationKey].length > 0) {
            return this.productVariationMobileImages[productCode][variationKey][0].image_url || 
                   this.productVariationMobileImages[productCode][variationKey][0].url || '';
        }
        return '';
    }

    // Check if variation has web images
    hasVariationWebImages(productCode: string, variationKey: string): boolean {
        return !!(this.productVariationWebImages[productCode] && 
                  this.productVariationWebImages[productCode][variationKey] && 
                  this.productVariationWebImages[productCode][variationKey].length > 0);
    }

    // Check if variation has mobile images
    hasVariationMobileImages(productCode: string, variationKey: string): boolean {
        return !!(this.productVariationMobileImages[productCode] && 
                  this.productVariationMobileImages[productCode][variationKey] && 
                  this.productVariationMobileImages[productCode][variationKey].length > 0);
    }

    // Get variation label
    getVariationLabel(variation: any): string {
        if (variation.color_mactile) {
            return `${variation.color_mactile} Color: ${variation.color_mactile}`;
        }
        // Use language-aware field selection
        const name = this.commonService.domDirectionLTR ? variation.product_name_en : variation.product_name_ar;
        if (name) {
            return name;
        }
        // Fallback to English if Arabic is not available
        if (variation.product_name_en) {
            return variation.product_name_en;
        }
        if (variation.product_name_ar) {
            return variation.product_name_ar;
        }
        if (variation.product_sku) {
            return variation.product_sku;
        }
        return 'N/A';
    }


    getFlattenedProductsList(): any[] {
        const flattened: any[] = [];
        const previewProducts = this.getPreviewProducts();
        if (previewProducts && previewProducts.length > 0) {
            previewProducts.forEach(product => {
                flattened.push({
                    isProduct: true,
                    product: product
                });
                if (product.sub_products && product.sub_products.length > 0) {
                    product.sub_products.forEach((variation: any) => {
                        flattened.push({
                            isProduct: false,
                            product: product,
                            variation: variation
                        });
                    });
                }
            });
        }
        return flattened;
    }


    getImagePreviewUrl(file: NzUploadFile | null): string {
        if (!file) return '';
        if (file.thumbUrl) {
            return file.thumbUrl;
        }
        if (file.url) {
            return file.url;
        }
        if (file.originFileObj) {
            return URL.createObjectURL(file.originFileObj);
        }
        return '';
    }


    getTotalVariationsCount(): number {
        let count = 0;
        if (this.successfulProducts && this.successfulProducts.length > 0) {
            this.successfulProducts.forEach(product => {
                const mode = this.getImageMode(product.product_code);
                if (mode === 'common') {
                    count += 1;
                } else {
                    if (product.variations && product.variations.length > 0) {
                        count += product.variations.length;
                    } else {
                        count += 1;
                    }
                }
            });
        }
        return count;
    }

    validateImages(): boolean {
        // Step 2 is mandatory - all items must have both web AND mobile images uploaded
        const totalItems = this.getTotalItemsCount();
        const itemsWithImages = this.getTotalItemsWithImages();
        return totalItems > 0 && itemsWithImages === totalItems;
    }

    // Check if product needs images uploaded (for badge display)
    needsProductImagesUploaded(product: any): boolean {
        const productKey = this.getProductKey(product);
        const imageMode = this.getImageMode(productKey);
        
        // For both common and unique mode, check if product itself has images
        // In common mode: product images are used for all variations
        // In unique mode: product itself can also have images (if required)
        const productHasImages = this.hasWebImagesUploaded(productKey) && this.hasMobileImagesUploaded(productKey);
        
        // Show badge if product doesn't have images
        return !productHasImages;
    }

    // Check if variation needs images uploaded (for badge display)
    needsVariationImagesUploaded(product: any, variation: any): boolean {
        const productKey = this.getProductKey(product);
        const variationKey = this.getVariationKey(variation, productKey);
        const imageMode = this.getImageMode(productKey);
        
        // If common mode, variations use product images - don't show badge on variations
        if (imageMode === 'common') {
            return false;
        }
        
        // If unique mode, check if this specific variation has its own images
        // Hide badge if variation has both web and mobile images
        const hasVariationImages = this.hasVariationWebImages(productKey, variationKey) && 
                                  this.hasVariationMobileImages(productKey, variationKey);
        return !hasVariationImages;
    }

    prepareImagesPayload(): any {
        const payload: any = {
            products: []
        };

        if (this.successfulProducts && this.successfulProducts.length > 0) {
            this.successfulProducts.forEach(product => {
                const mode = this.getImageMode(product.product_code);
                const isCommonMode = mode === 'common';
                
                const productPayload: any = {
                    product_code: product.product_code,
                    apply_common_image: isCommonMode,
                    images: []
                };

                // Images are now uploaded via zip upload API, so payload is not needed here
                // This method is kept for backward compatibility but images are handled separately

                payload.products.push(productPayload);
            });
        }

        return payload;
    }

    getTotalImagesUploadedCount(): number {
        // Count products with at least web or mobile images uploaded
        let count = 0;
        const previewProducts = this.getPreviewProducts();
        if (previewProducts && previewProducts.length > 0) {
            previewProducts.forEach(product => {
                const productKey = this.getProductKey(product);
                if (this.hasWebImagesUploaded(productKey) || this.hasMobileImagesUploaded(productKey)) {
                    count += 1;
                }
            });
        }
        return count;
    }

    submit(type: string): void {
        if (type === 'upload') {
            // Handle final submission
            this.notification.success('Success', 'Bulk upload completed successfully');
            this.handleCancel();
        }
    }

    // Get first web image
    getFirstWebImage(productCode: string): string {
        if (this.productWebImages[productCode] && this.productWebImages[productCode].length > 0) {
            return this.productWebImages[productCode][0].image_url || this.productWebImages[productCode][0].url || '';
        }
        return '';
    }

    // Get first mobile image
    getFirstMobileImage(productCode: string): string {
        if (this.productMobileImages[productCode] && this.productMobileImages[productCode].length > 0) {
            return this.productMobileImages[productCode][0].image_url || this.productMobileImages[productCode][0].url || '';
        }
        return '';
    }

    // Get first variation web image
    getFirstVariationWebImage(productCode: string, variationKey: string): string {
        if (this.productVariationWebImages[productCode] && 
            this.productVariationWebImages[productCode][variationKey] && 
            this.productVariationWebImages[productCode][variationKey].length > 0) {
            return this.productVariationWebImages[productCode][variationKey][0].image_url || 
                   this.productVariationWebImages[productCode][variationKey][0].url || '';
        }
        return '';
    }

    // Get first variation mobile image
    getFirstVariationMobileImage(productCode: string, variationKey: string): string {
        if (this.productVariationMobileImages[productCode] && 
            this.productVariationMobileImages[productCode][variationKey] && 
            this.productVariationMobileImages[productCode][variationKey].length > 0) {
            return this.productVariationMobileImages[productCode][variationKey][0].image_url || 
                   this.productVariationMobileImages[productCode][variationKey][0].url || '';
        }
        return '';
    }

    // Get all web images
    getAllWebImages(productCode: string): any[] {
        return this.productWebImages[productCode] || [];
    }

    // Get all mobile images
    getAllMobileImages(productCode: string): any[] {
        return this.productMobileImages[productCode] || [];
    }

    // Get all variation web images
    getAllVariationWebImages(productCode: string, variationKey: string): any[] {
        return (this.productVariationWebImages[productCode] && 
                this.productVariationWebImages[productCode][variationKey]) || [];
    }

    // Get all variation mobile images
    getAllVariationMobileImages(productCode: string, variationKey: string): any[] {
        return (this.productVariationMobileImages[productCode] && 
                this.productVariationMobileImages[productCode][variationKey]) || [];
    }

    // View all web images
    viewAllWebImages(productCode: string): void {
        const images = this.getAllWebImages(productCode);
        if (images.length === 0) return;
        this.openImageGalleryModal(images, 'Web Images');
    }

    // View all mobile images
    viewAllMobileImages(productCode: string): void {
        const images = this.getAllMobileImages(productCode);
        if (images.length === 0) return;
        this.openImageGalleryModal(images, 'Mobile Images');
    }

    // View all variation web images
    viewAllVariationWebImages(productCode: string, variationKey: string): void {
        const images = this.getAllVariationWebImages(productCode, variationKey);
        if (images.length === 0) return;
        this.openImageGalleryModal(images, 'Variation Web Images');
    }

    // View all variation mobile images
    viewAllVariationMobileImages(productCode: string, variationKey: string): void {
        const images = this.getAllVariationMobileImages(productCode, variationKey);
        if (images.length === 0) return;
        this.openImageGalleryModal(images, 'Variation Mobile Images');
    }

    // Has variation web cover image
    hasVariationWebCoverImage(productCode: string, variationKey: string): boolean {
        const images = this.getAllVariationWebImages(productCode, variationKey);
        return images.some((img: any) => img.is_cover_image || img.is_cover_images);
    }

    // Has variation mobile cover image
    hasVariationMobileCoverImage(productCode: string, variationKey: string): boolean {
        const images = this.getAllVariationMobileImages(productCode, variationKey);
        return images.some((img: any) => img.is_cover_image || img.is_cover_images);
    }

    // Open image gallery modal using Ionic ModalController
    async openImageGalleryModal(images: any[], title: string): Promise<void> {
        // Find cover image index (default selected)
        let defaultIndex = 0;
        images.forEach((img, index) => {
            if (img.is_cover_image || img.is_cover_images) {
                defaultIndex = index;
            }
        });
        
        // Create a simple modal component dynamically
        const modal = await this.modalCtrl.create({
            component: ImageGalleryModalComponent,
            componentProps: {
                images: images,
                title: title,
                defaultIndex: defaultIndex
            },
            cssClass: 'image-gallery-modal',
            showBackdrop: true,
            backdropDismiss: true
        });
        
        await modal.present();
    }

    // ========== Preview Step Methods ==========

    // Toggle preview product row expansion
    togglePreviewProductRow(productCode: string): void {
        this.expandedPreviewProductRows[productCode] = !this.expandedPreviewProductRows[productCode];
    }

    // Check if preview product row is expanded
    isPreviewProductRowExpanded(productCode: string): boolean {
        return !!this.expandedPreviewProductRows[productCode];
    }

    // Get total items count (products + variations)
    getTotalItemsCount(): number {
        const products = this.getPreviewProducts();
        let count = 0;
        products.forEach((product: any) => {
            count += 1; // Product itself
            if (product.sub_products && product.sub_products.length > 0) {
                count += product.sub_products.length; // Variations
            }
        });
        return count;
    }

    // Get total items with images (both web and mobile are required)
    getTotalItemsWithImages(): number {
        const products = this.getPreviewProducts();
        let count = 0;
        products.forEach((product: any) => {
            const productKey = this.getProductKey(product);
            const imageMode = this.getImageMode(productKey);
            // Both web AND mobile images are required
            const hasProductImages = this.hasWebImagesUploaded(productKey) && this.hasMobileImagesUploaded(productKey);
            
            // Check product images
            if (hasProductImages) {
                count += 1;
            }
            
            // Check variation images
            if (product.sub_products && product.sub_products.length > 0) {
                product.sub_products.forEach((variation: any) => {
                    const variationKey = this.getVariationKey(variation, productKey);
                    // For common mode, variations use product images, so count them if product has both web and mobile images
                    // For unique mode, check if variation has both web and mobile images
                    if (imageMode === 'common') {
                        if (hasProductImages) {
                            count += 1;
                        }
                    } else {
                        // Both web AND mobile images are required for variations in unique mode
                        if (this.hasVariationWebImages(productKey, variationKey) && 
                            this.hasVariationMobileImages(productKey, variationKey)) {
                            count += 1;
                        }
                    }
                });
            }
        });
        return count;
    }

    // Get total items without images
    getTotalItemsWithoutImages(): number {
        return this.getTotalItemsCount() - this.getTotalItemsWithImages();
    }

    // Get total main products (not including variations)
    getTotalMainProducts(): number {
        return this.getPreviewProducts().length;
    }

    // Get total sub products (variations)
    getTotalSubProducts(): number {
        const products = this.getPreviewProducts();
        let count = 0;
        products.forEach((product: any) => {
            if (product.sub_products && product.sub_products.length > 0) {
                count += product.sub_products.length;
            }
        });
        return count;
    }

    // Get total image required (each product and variation needs 2 images: web + mobile)
    getTotalImageRequired(): number {
        const products = this.getPreviewProducts();
        let count = 0;
        products.forEach((product: any) => {
            count += 2; // Product needs web + mobile = 2 images
            if (product.sub_products && product.sub_products.length > 0) {
                product.sub_products.forEach(() => {
                    count += 2; // Each variation needs web + mobile = 2 images
                });
            }
        });
        return count;
    }

    // Get total required images (products + variations, each needs web + mobile = 2)
    getTotalRequiredImages(): number {
        const products = this.getPreviewProducts();
        let count = 0;
        products.forEach((product: any) => {
            count += 2; // Product needs web + mobile
            if (product.sub_products && product.sub_products.length > 0) {
                product.sub_products.forEach(() => {
                    count += 2; // Each variation needs web + mobile
                });
            }
        });
        return count;
    }

    // Get total uploaded images (count all uploaded images)
    getTotalUploadedImages(): number {
        const products = this.getPreviewProducts();
        let count = 0;
        products.forEach((product: any) => {
            const productKey = this.getProductKey(product);
            const imageMode = this.getImageMode(productKey);
            
            // Count product images
            if (this.hasWebImagesUploaded(productKey)) {
                const webImages = this.productWebImages[productKey] || [];
                count += webImages.length;
            }
            if (this.hasMobileImagesUploaded(productKey)) {
                const mobileImages = this.productMobileImages[productKey] || [];
                count += mobileImages.length;
            }
            
            // Count variation images
            if (product.sub_products && product.sub_products.length > 0) {
                product.sub_products.forEach((variation: any) => {
                    const variationKey = this.getVariationKey(variation, productKey);
                    if (imageMode === 'unique') {
                        if (this.hasVariationWebImages(productKey, variationKey)) {
                            const webImages = this.productVariationWebImages[productKey]?.[variationKey] || [];
                            count += webImages.length;
                        }
                        if (this.hasVariationMobileImages(productKey, variationKey)) {
                            const mobileImages = this.productVariationMobileImages[productKey]?.[variationKey] || [];
                            count += mobileImages.length;
                        }
                    }
                });
            }
        });
        return count;
    }

    // Get total variations
    getTotalVariations(): number {
        const products = this.getPreviewProducts();
        let count = 0;
        products.forEach((product: any) => {
            if (product.sub_products && product.sub_products.length > 0) {
                count += product.sub_products.length;
            }
        });
        return count;
    }

    // Get variations with images
    getVariationsWithImages(): number {
        const products = this.getPreviewProducts();
        let count = 0;
        products.forEach((product: any) => {
            const productKey = this.getProductKey(product);
            const imageMode = this.getImageMode(productKey);
            const hasProductImages = this.hasWebImagesUploaded(productKey) && this.hasMobileImagesUploaded(productKey);
            
            if (product.sub_products && product.sub_products.length > 0) {
                product.sub_products.forEach((variation: any) => {
                    const variationKey = this.getVariationKey(variation, productKey);
                    let hasImages = false;
                    
                    if (imageMode === 'common') {
                        hasImages = hasProductImages;
                    } else {
                        hasImages = this.hasVariationWebImages(productKey, variationKey) && 
                                   this.hasVariationMobileImages(productKey, variationKey);
                    }
                    
                    if (hasImages) {
                        count++;
                    }
                });
            }
        });
        return count;
    }

    // Get variations without images
    getVariationsWithoutImages(): number {
        return this.getTotalVariations() - this.getVariationsWithImages();
    }

    // Get first product web image from preview response data
    // Structure: product.product_images = [{ web_images: [...] }, { mobile_images: [...] }]
    getFirstProductWebImage(product: any): string {
        if (!product || !product.product_images || !Array.isArray(product.product_images)) {
            return '';
        }
        // Find the object with web_images
        for (const imgObj of product.product_images) {
            if (imgObj.web_images && Array.isArray(imgObj.web_images) && imgObj.web_images.length > 0) {
                const firstWebImage = imgObj.web_images[0];
                return firstWebImage.image_url || firstWebImage.url || '';
            }
        }
        return '';
    }

    // Get first product mobile image from preview response data
    // Structure: product.product_images = [{ web_images: [...] }, { mobile_images: [...] }]
    getFirstProductMobileImage(product: any): string {
        if (!product || !product.product_images || !Array.isArray(product.product_images)) {
            return '';
        }
        // Find the object with mobile_images
        for (const imgObj of product.product_images) {
            if (imgObj.mobile_images && Array.isArray(imgObj.mobile_images) && imgObj.mobile_images.length > 0) {
                const firstMobileImage = imgObj.mobile_images[0];
                return firstMobileImage.image_url || firstMobileImage.url || '';
            }
        }
        return '';
    }

    // Get first variation web image directly from preview response data
    // Structure: variation.product_images = [{ web_images: [...] }, { mobile_images: [...] }]
    getFirstVariationWebImageFromPreview(variation: any): string {
        if (!variation || !variation.product_images || !Array.isArray(variation.product_images)) {
            return '';
        }
        // Find the object with web_images
        for (const imgObj of variation.product_images) {
            if (imgObj.web_images && Array.isArray(imgObj.web_images) && imgObj.web_images.length > 0) {
                const firstWebImage = imgObj.web_images[0];
                return firstWebImage.image_url || firstWebImage.url || '';
            }
        }
        return '';
    }

    // Get first variation mobile image directly from preview response data
    // Structure: variation.product_images = [{ web_images: [...] }, { mobile_images: [...] }]
    getFirstVariationMobileImageFromPreview(variation: any): string {
        if (!variation || !variation.product_images || !Array.isArray(variation.product_images)) {
            return '';
        }
        // Find the object with mobile_images
        for (const imgObj of variation.product_images) {
            if (imgObj.mobile_images && Array.isArray(imgObj.mobile_images) && imgObj.mobile_images.length > 0) {
                const firstMobileImage = imgObj.mobile_images[0];
                return firstMobileImage.image_url || firstMobileImage.url || '';
            }
        }
        return '';
    }

    // Get product warehouse from successfulProducts (same as step 0)
    getProductWarehouse(product: any): string {
        if (!this.successfulProducts || !Array.isArray(this.successfulProducts)) {
            return '';
        }
        // Find matching product from successfulProducts by product_code or product_id
        const productCode = product.product_code || product.product_id?.toString();
        const matchingProduct = this.successfulProducts.find((p: any) => 
            p.product_code === productCode || 
            (p.variations && p.variations.length > 0 && p.variations[0].product_code === productCode)
        );
        if (matchingProduct && matchingProduct.warehouses) {
            return matchingProduct.warehouses; // This is a string like "ABC warehouse,Thakar Dharmkata"
        }
        return '';
    }

    // Get product quantity from successfulProducts (same as step 0)
    getProductQuantity(product: any): string {
        if (!this.successfulProducts || !Array.isArray(this.successfulProducts)) {
            return '';
        }
        // Find matching product from successfulProducts by product_code or product_id
        const productCode = product.product_code || product.product_id?.toString();
        const matchingProduct = this.successfulProducts.find((p: any) => 
            p.product_code === productCode || 
            (p.variations && p.variations.length > 0 && p.variations[0].product_code === productCode)
        );
        if (matchingProduct && matchingProduct.total_quantity) {
            return matchingProduct.total_quantity.toString();
        }
        return '';
    }

    // Get variation warehouses (array of warehouse objects) from preview products
    getVariationWarehouses(variation: any): any[] {
        // First try to get from preview products (step 3)
        const previewProducts = this.getPreviewProducts();
        if (previewProducts && previewProducts.length > 0) {
            const variationSku = variation.product_sku || variation.supplier_product_sku;
            if (variationSku) {
                for (const product of previewProducts) {
                    if (product.sub_products && Array.isArray(product.sub_products)) {
                        const matchingVariation = product.sub_products.find((v: any) => 
                            v.product_sku === variationSku || v.supplier_product_sku === variationSku
                        );
                        if (matchingVariation && matchingVariation.inventory && Array.isArray(matchingVariation.inventory)) {
                            // Convert inventory array to warehouse format
                            return matchingVariation.inventory.map((inv: any) => ({
                                warehouse_id: inv.warehouse_id,
                                warehouse_name: inv.warehouse_name || 
                                              (this.commonService.domDirectionLTR ? inv.warehouse_title_en : inv.warehouse_title_ar) ||
                                              inv.warehouse_title_en || 
                                              inv.warehouse_title_ar,
                                quantity: inv.quantity || inv.available_quantity || 0
                            }));
                        }
                    }
                }
            }
        }
        
        // Fallback to successfulProducts (step 0)
        if (!this.successfulProducts || !Array.isArray(this.successfulProducts)) {
            return [];
        }
        const variationSku = variation.product_sku || variation.supplier_product_sku;
        if (!variationSku) {
            return [];
        }
        // Search through all products and their variations
        for (const product of this.successfulProducts) {
            if (product.variations && Array.isArray(product.variations)) {
                const matchingVariation = product.variations.find((v: any) => 
                    v.product_sku === variationSku || v.supplier_product_sku === variationSku
                );
                if (matchingVariation && matchingVariation.warehouses && Array.isArray(matchingVariation.warehouses)) {
                    return matchingVariation.warehouses;
                }
            }
        }
        return [];
    }

    // Get successful product count from preview API response
    getSuccessfulProductCount(): number {
        if (this.previewResponseData && this.previewResponseData.data && this.previewResponseData.data.total_main_products !== undefined) {
            return this.previewResponseData.data.total_main_products || 0;
        }
        // Fallback to counting products array if total_main_products is not available
        const products = this.getPreviewProducts();
        return products ? products.length : 0;
    }

    // View product details in modal
    viewProductDetails(productId: number): void {
        if (!productId) {
            this.notification.error('Error', 'Product ID is required');
            return;
        }

        // Open ProductPreviewComponent in modal (same UI as view-product page)
        let obj = {
            component: ProductPreviewComponent,
            backdropDismiss: false,
            cssClass: 'preview-modal',
            componentProps: {
                modalProductId: productId
            },
        };
        const modal = this.modalService.openModal(obj);
        modal.then(value => {
            // Modal closed
        }, error => {
            console.log(error);
        });
    }

    // Handle complete step - close modal
    handleComplete(): void {
        this.resetModal();
        // Close using Ionic ModalController
        this.modalCtrl.dismiss(true);
    }
}

